export default {
  title: "Feedback",
  context: "Context",
  subject_label: "Subject",
  long_text_label: "Your feedback",
  notice_label: "Your product feedback is sent to <b class='text-info'>{company}</b>.",
  bug_label: "This feedback concerns a software problem (bug).",
  feedback_success: "Feedback data submitted successfully",
  feedback_error: "Failed to send feedback data",
}
